/**
 *  Register.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";
import { withRouter } from "react-router-dom";

// Tables
import {
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  Toolbar,
  TableHeaderRow,
  PagingPanel,
  SearchPanel,
} from "@devexpress/dx-react-grid-bootstrap3";

// notifications
import NotificationSystem from "react-notification-system";

// style
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");
var utils = require("../../utils");

class DangerZoneList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {
          name: "createdAt",
          title: "Criado Em",
          getCellValue: (row) => utils.dateTimeFormatter(row.createdAt),
        },
        { name: "name", title: "Nome" },
        // {name: "location", title: "Local",
        //   getCellValue: row => `${row.lat}, ${row.long}`
        // },
        // {name: "radius", title: "Raio"},
        {
          name: "meeting",
          title: "Ponto Encontro",
          getCellValue: (row) => `${row.meetingLat}, ${row.meetingLong}`,
        },
        {
          name: "actions",
          title: "Ações",
          getCellValue: (row) => this.actions(row),
        },
      ],
      _notificationSystem: null,
      searchValue: "",
      sortColumns: [],
      tableColumnExtensions: [],
    };

    this.changeSearchValue = (value) => this.setState({ searchValue: value });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  actions = (row) => {
    return (
      <div>
        <a
          onClick={() => {
            this.disable(row);
          }}
          className="link-edit"
        >
          <span className="text-danger" style={{ fontWeight: "bold" }}>
            <i className={`glyphicon glyphicon-remove`} /> REMOVER
          </span>
        </a>
      </div>
    );
  };

  disable = (row) => {
    const { reload } = this.props;
    this.notify("Desativado com sucesso", "success");
    firebase.database
      .ref(`dangerZone/${row.key}`)
      .update({ status: 0 })
      .then((_) => {
        reload();
      });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const { columns, searchValue, sortColumns, tableColumnExtensions } =
      this.state;
    const { list } = this.props;

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />

        <Grid rows={list} columns={columns}>
          <SearchState
            value={searchValue}
            onValueChange={this.changeSearchValue}
          />

          <PagingState defaultCurrentPage={0} defaultPageSize={20} />

          <SortingState defaultSorting={sortColumns} />

          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />

          <Table columnExtensions={tableColumnExtensions} />
          <TableHeaderRow showSortingControls />
          <Toolbar />

          <SearchPanel />

          <PagingPanel pageSizes={[5, 15, 20, 25, 50, 100, 0]} />
        </Grid>
      </div>
    );
  }
}

export default withRouter(DangerZoneList);



// WEBPACK FOOTER //
// ./src/views/DangerZone/DangerZoneList.jsx